import { AxiosResponse } from 'axios';
import { useAuth } from 'core/contexts';
import {
    withHeaders,
    instance as axiosInstance,
} from 'core/util/axiosInstance';
import { getDefaultHeaders } from 'core/util/other';
import { useQuery, UseQueryResult } from 'react-query';
import { EdgeDefinition } from 'lib';

const getQueryData = async (
    token: string
): Promise<AxiosResponse<EdgeDefinition[], any>> => {
    const headers = getDefaultHeaders(token);

    const response = await axiosInstance().get(
        '/metadata/edge',
        withHeaders(headers)
    );

    return response;
};

export const useEdgeDefinitionList = (): UseQueryResult<
    AxiosResponse<EdgeDefinition[], any>,
    unknown
> => {
    const { getToken } = useAuth();
    // const { onSuccess, onError, chain } = props;

    return useQuery(`edge definitions`, async () => getQueryData(getToken()));
};
